import React from "react";
import Context from "../../../../context";
import {
  CustomView,
  CustomModal,
  CustomButton2,
  UserInformation,
} from "../../../../components";

import "./index.scss";
import ImageViewer from "../../../../components/ImageViewer";
import { useTranslation } from "react-i18next";

const ApproveDocuments = () => {
  const {
    showModal,
    setShowModal,
    isLoading,
    selectedCompany,
    approveDocumentsFunction,
  } = React.useContext(Context.CompanyScreen);

  const { t } = useTranslation();

  // ?? ===========================================================================================================
  // ??                                              JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------
  return (
    <section id="driver-approve-modal-container">
      <CustomModal
        onClose={() => setShowModal!("NONE")}
        open={showModal === "APPROVE_DOCUMENTS"}
        //label="تایید مدارک شرکت"
        minWidth={"45rem"}
      >
        <CustomView.Row className="documents-container">
          <CustomView.Column medium={4}>
            <ImageViewer
              imageUrl={
                selectedCompany?.companyInformation?.documents
                  ?.nationalCardFront
              }
            />
          </CustomView.Column>{" "}
          <CustomView.Column medium={4}>
            <ImageViewer
              imageUrl={
                selectedCompany?.companyInformation?.documents?.nationalCardBack
              }
            />
          </CustomView.Column>{" "}
          <CustomView.Column medium={4}>
            <ImageViewer
              imageUrl={
                selectedCompany?.companyInformation?.documents?.companyLicence
              }
            />
          </CustomView.Column>{" "}
        </CustomView.Row>
        <CustomView.Row className="form-row">
          <CustomView.Column
            large={3}
            medium={4}
            small={6}
            className="form-colum"
          >
            <CustomButton2
              isLoading={isLoading}
              onClick={() => setShowModal!("NONE")}
              title={t("cancel")}
              type="danger"
            />
          </CustomView.Column>
          <CustomView.Column
            large={3}
            medium={4}
            small={6}
            className="form-colum"
          >
            <CustomButton2
              isLoading={isLoading}
              onClick={() => approveDocumentsFunction!(selectedCompany?._id)}
              title={t("approve")}
            />
          </CustomView.Column>
        </CustomView.Row>
      </CustomModal>
    </section>
  );
};

export default ApproveDocuments;
